import { render, staticRenderFns } from "./SettingsEmailTemplateSendTestPopup.vue?vue&type=template&id=2f1b300e"
import script from "./SettingsEmailTemplateSendTestPopup.vue?vue&type=script&lang=ts"
export * from "./SettingsEmailTemplateSendTestPopup.vue?vue&type=script&lang=ts"
import style0 from "./SettingsEmailTemplateSendTestPopup.vue?vue&type=style&index=0&id=2f1b300e&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports